<template>
  <section class="documents">
    <div class="container">
      <v-app>
        <div class="pa-7">
          <h1>Manutenção dos items</h1>
          <v-divider class="mt-1 mb-5"></v-divider>

          <v-container fluid>
            <v-row dense>
              <v-col
                cols="12"
              >
                <v-card
                  color="#005a64"
                  dark
                >
                  <div class="d-flex flex-no-wrap justify-space-between align-center">
                    <div>
                      <v-card-title
                        class="text-h5"
                      ><b>Kit selecionado:</b></v-card-title>
                      <v-card-title
                        class="text-h5"
                      >{{ kit.NOME_ITEM }}</v-card-title>
                      <v-card-subtitle><b>SKU: </b><span>{{ kit.SKU }}</span></v-card-subtitle>

                    </div>

                    <v-avatar
                      class="ma-3"
                      size="125"
                      tile
                    >
                      <v-img :src="kit.URLIMAGEM"></v-img>
                    </v-avatar>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <div class="mt-10">

            <a-skeleton class="mt-10" :loading="loading" active >
            </a-skeleton>

            <v-expansion-panels v-if="components.length > 0" class="elevation-5" >
              <v-expansion-panel
                v-for="(component,i) in components"
                :key="i"
              >
                <v-expansion-panel-header>
                  {{ component.DESCRIPTION }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :headers="headers"
                    :items="component.ITEMS"
                    class="elevation-1"
                    :search="search"
                    :loading="loading"
                    loading-text="Carregando kit's..."
                  >

                    <a-skeleton class="mt-10" :loading="loading" active slot="progress" >
                    </a-skeleton>

                    <template v-slot:top>
                      <v-text-field
                        v-model="search"
                        label="Filtro"
                        class="mx-4"
                        color="#005a64"
                      >
                        <v-icon
                          slot="append"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-text-field>
                    </template>

                    <template v-slot:[`item.IMGITEM`]="{ item }">
                      <v-img
                        class="ma-3"
                        aspect-ratio="1"
                        max-height="100"
                        min-height="100"
                        min-width="100"
                        max-width="100"
                        :lazy-src="item.IMGITEM"
                        :src="item.IMGITEM"
                      ></v-img>
                    </template>

                    <template v-slot:[`item.DESCRIPTION`]="{ item }">
                      <div>
                        {{ item.DESCRIPTION }}
                      </div>
                    </template>

                    <template v-slot:[`item.options`]="{ item }">
                      <div class="ma-5">
                        {{item.options}}
                        <v-btn
                          @click="openComponentModal(item), parentArray = component.ITEMS"
                          class="mx-2"
                          fab
                          dark
                          small
                          color="blue"
                        >
                          <v-icon dark>
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="red"
                          @click="openConfirmDialogToRemove(item, component.ITEMS)"
                        >
                          <v-icon dark>
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </div>
                    </template>

                  </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <v-btn
          v-if="components.length > 0"
          fab
          dark
          fixed
          right
          bottom
          color="#005a64"
          @click="window.scrollTo(0,0)"
        >
          <v-icon dark>mdi-arrow-up</v-icon>
        </v-btn>

        <v-dialog
          transition="dialog-bottom-transition"
          max-width="600"
          v-model="editDialog.active"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="#005a64"
                dark
              >{{ editComponent.DESCRIPTION }}</v-toolbar>
              
              <v-card-text class="mt-4">
                <div>
                  <b>*Atenção!</b> Os campos refletem exatamente os campos da tabela de componentes, as alterações realizadas serão refletidas imediatamente nos kit's.
                </div>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="mt-4"
                >
                  <v-text-field
                    v-model="editComponent.SKU_PRINCIPAL"
                    label="SKU_PRINCIPAL"
                    required
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.KITS"
                    label="KITS"
                    required
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.COMPONENTES"
                    label="COMPONENTES"
                    required
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.DATA_ALTERACAO"
                    label="DATA_ALTERACAO"
                    type="datetime-local"
                    required
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.USUARIO_ALTERACAO"
                    label="USUARIO_ALTERACAO"
                    required
                    disabled
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.DESCRIPTION"
                    label="DESCRIPTION"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.CHECKED_ITEM"
                    label="CHECKED_ITEM"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.DESCRIPTION_ITEM"
                    label="DESCRIPTION_ITEM"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.ESTAGIOS"
                    label="ESTAGIOS"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.INC"
                    label="INC"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.SUG"
                    label="SUG"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.MAX"
                    label="MAX"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.MIN"
                    label="MIN"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.POTENCIA"
                    label="POTENCIA"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.POTENCIA_CV"
                    label="POTENCIA_CV"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.PRAZO_ESTOQUE"
                    label="PRAZO_ESTOQUE"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.SKUS"
                    label="SKUS"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.VALIDA_ESTOQUE"
                    label="VALIDA_ESTOQUE"
                    required
                  ></v-text-field>
                  <v-text-field
                    v-model="editComponent.IMGITEM"
                    label="IMGITEM"
                    required
                  ></v-text-field>
                </v-form>
              </v-card-text>

              <v-card-actions class="justify-end">
                <v-btn
                  color="#005a64"
                  text
                  @click="openConfirmDialogSaveEditedComponent(editComponent)"
                >Save</v-btn>
                <v-btn
                  text
                  @click="dialog.value = false"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

        <!-- Modal de Loading -->
        <v-dialog v-model="loadingModal.active" persistent width="300">
          <v-card color="#005a64" dark>
            <v-card-text style="padding: 27px">
              {{ loadingModal.message }}
              <v-progress-linear
                style="margin-top: 15px"
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- Modal de Dialogo -->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="600"
          v-model="dialogController.active"
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="#005a64"
                dark
              >{{ dialogController.header }}</v-toolbar>

              <v-card-text class="mt-8" v-html="dialogController.message">
              </v-card-text>

              <v-card-actions class="justify-space-between">
                <v-btn
                  v-if="dialogController.action"
                  color="#005a64"
                  text
                  @click="dialogController.action"
                >OK</v-btn>
                <v-btn
                  v-if="!dialogController.actionOnClose"
                  text
                  @click="dialog.value = false"
                >Close</v-btn>
                <v-btn
                  v-else
                  text
                  @click="dialogController.actionOnClose"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>

      </v-app>
    </div>
  </section>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      baseUrl: `https://www.leverosintegra.com.br/Map/Api`,
      components: [],
      kit: {
        SKU: null,
        NOME_ITEM: null,
      },
      editComponent: {},
      parentArray: [],
      editDialog: {
        active: false,
      },
      search: null,
      loading: false,
      loadingModal: {
        active: false,
        message: null
      },
      dialogController: {
        active: false,
        header: null,
        message: null,
        action: null,
        actionOnClose: null
      },
      window: window,
      headers: [
        {
          text: '',
          value: 'IMGITEM',
          sortable: false,
        },
        {
          text: 'Descrição',
          value: 'DESCRIPTION',
          sortable: false,
        },
        {
          text: '',
          value: 'options',
          sortable: false,
        },
      ],
      valid: true,
    }
  },

  created() {
    const { Kit } = this.$route.query

    let dados = JSON.parse(localStorage.getItem("login"));
    this.token = dados.token;


    this.kit = JSON.parse(Kit)

    this.loading = true
    axios.get(
      `${this.baseUrl}/solar?token=${this.token}&function=items&sku=${this.kit.SKU}`
    ).then(res => {
      this.components = res.data
      this.loading = false
    }).catch(err => {
      if (err && err.response && err.response.status === 401) {
        window.location = '/login';
        return;
      }
      alert(err)
      this.loading = false
    })
  },

  methods: {
    openComponentModal(comp) {
      this.editComponent = comp
      this.editDialog.active = true
    },
    openConfirmDialogSaveEditedComponent(comp) {
      this.dialogController.header = `Atenção!`
      this.dialogController.message =
        `Ao prosseguir o componente <b>${comp.DESCRIPTION}</b> será <b>atualizado</b> na base de dados!
        <br><br>
        Essa ação irá refletir imediatamente no kit
        <br>
        Deseja continuar?`
      this.dialogController.action = () => {
        this.saveEditedComponent(comp)
      }
      this.dialogController.actionOnClose = null
      this.dialogController.active = true
    },
    saveEditedComponent(comp) {
      this.loadingModal.message = `Atualizando componente da base de dados...`
      this.loadingModal.active = true

      axios.post(
        `${this.baseUrl}/solar?token=${this.token}&function=update`,
        {
          comp
        }
      ).then(res => {
        console.log(res)

        // Atualiza visualização
        comp.CATEGORIA = res.data.CATEGORIA
        comp.CHECKED_ITEM = res.data.CHECKED_ITEM
        comp.COMPONENTES = res.data.COMPONENTES
        comp.DATA_ALTERACAO = res.data.DATA_ALTERACAO.split('.')[0]
        comp.DESCRIPTION = res.data.DESCRIPTION
        comp.DESCRIPTION_ITEM = res.data.DESCRIPTION_ITEM
        comp.ESTAGIOS = res.data.ESTAGIOS
        comp.ID = res.data.ID
        comp.ID_COMPONENT = res.data.ID_COMPONENT
        comp.IMGITEM = res.data.IMGITEM
        comp.INC = res.data.INC
        comp.KITS = res.data.KITS
        comp.MAX = res.data.MAX
        comp.MIN = res.data.MIN
        comp.POTENCIA = res.data.POTENCIA
        comp.POTENCIA_CV = res.data.POTENCIA_CV
        comp.PRAZO_ESTOQUE = res.data.PRAZO_ESTOQUE
        comp.SKUS = res.data.SKUS
        comp.SKU_PRINCIPAL = res.data.SKU_PRINCIPAL
        comp.SUG = res.data.SUG
        comp.USUARIO_ALTERACAO = res.data.USUARIO_ALTERACAO
        comp.VALIDA_ESTOQUE = res.data.VALIDA_ESTOQUE

        this.dialogController.header = `Sucesso!`
        this.dialogController.message =
          `Componente <b>${comp.DESCRIPTION}</b> atualizado com sucesso!`
        this.dialogController.action = null
        this.dialogController.actionOnClose = null
        this.loadingModal.active = false
        this.dialogController.active = true

      }).catch(err => {
        if (err && err.response && err.response.status === 401) {
          window.location = '/login';
          return;
        }
        this.loadingModal.active = false
        alert(err)
      })
    },
    openConfirmDialogToRemove(comp, parentArray) {
      this.dialogController.header = `Atenção!`
      this.dialogController.message =
        `Ao prosseguir o componente <b>${comp.DESCRIPTION}</b> será <b>removido</b> da base de dados!
        <br><br>
        Essa ação irá refletir imediatamente no kit
        <br>
        Deseja continuar?`
      this.dialogController.action = () => {
        this.removeComponent(comp, parentArray)
      }
      this.dialogController.actionOnClose = null
      this.dialogController.active = true
    },
    removeComponent(comp, parentArray) {
      this.loadingModal.message = `Removendo componente da base de dados...`
      this.loadingModal.active = true

      axios.post(
        `${this.baseUrl}/solar?token=${this.token}&function=delete`,
        {
          id: comp.ID
        }
      ).then(res => {
        console.log(res)

        // Remove da visualização
        let index = parentArray.indexOf(comp)
        parentArray.splice(index, 1)


        this.dialogController.header = `Sucesso!`
        this.dialogController.message =
          `Componente <b>${comp.DESCRIPTION}</b> removido com sucesso!`
        this.dialogController.action = null
        this.dialogController.actionOnClose = null
        this.loadingModal.active = false
        this.dialogController.active = true
        
      }).catch(err => {
        if (err && err.response && err.response.status === 401) {
          window.location = '/login';
          return;
        }
        this.loadingModal.active = false
        alert(err)
      })
    }
  },

}
</script>

<style lang="scss" scoped>
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--customGray-500);
        outline: none;
        margin-left: 20px;
        color: var(--customGray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--customBlue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--customGray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--customGray-100);
              text-align: center;

              button {
                background: var(--customGray-100);
                color: var(--customGray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--customDarkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>